import React from "react";
import UIButton from "../../../../../globalComponents/UIComponents/UIButton";
import './style.scss';

const className = 'prize-details';

export default ({ prize, priceStr, user, userBalance, loadingShopData, renderHint, $locale, renderGetPrizeModal }) => {

    const title = $locale.getProperty(prize, 'title');
    const photo = prize.images?.[0]?.fileUrl;
    const available = prize.inStock ? prize.totalLimit - prize.totalSold : 0;
    const unavailableForUser = prize.unavailableForUser;

    return <div className={`${className}-modal`}>
        <div className={`${className}-image-container`}>
            {photo && <img src={photo} alt={title} />}
        </div>
        <div className={`${className}-info-container`}>
            <div className={`${className}-available`}>{$locale.get('shop.available')} {available} / {prize.totalLimit}</div>
            <div className={`${className}-title`}>{title}</div>
            <div className={`${className}-price`}>{priceStr}</div>
            <div className={`${className}-get-prize-container`}>
                <UIButton
                    color="primary"
                    size="large"
                    disabled={!user || !available || prize.price > userBalance || unavailableForUser || loadingShopData}
                    onClick={renderGetPrizeModal}>
                    {$locale.get('shop.getPrize')}
                </UIButton>
                {user && <span className={`${className}-hint`}>{renderHint()}</span>}                
            </div>
            <div className={`${className}-description scrollable`}>{$locale.getProperty(prize, 'description')}</div>
        </div>
    </div>
}